import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { renderLegalUrl } from '../legal/render-legal.data';
import { RENDER_FULL_ETA, RENDER_START_CONSENT } from '../render.data';

export interface RenderUnlockDialogData {
  name: string;
}

// "Unlock your pack" (designer, Figma 28583:58754, 2026-09-24): the library's download button on a
// model that has only its free preview. Back to the library, or on to paying for this model —
// closes with 'pay'; the library starts the checkout.
@Component({
  selector: 'app-render-unlock-dialog',
  templateUrl: './render-unlock-dialog.component.html',
  styleUrls: ['./render-unlock-dialog.component.scss'],
})
export class RenderUnlockDialogComponent {
  // What paying agrees to, as under the preview's order card.
  public readonly termsUrl = renderLegalUrl('terms');
  public readonly refundsUrl = renderLegalUrl('refunds');
  public readonly fullEta = RENDER_FULL_ETA;
  public readonly startConsentText = RENDER_START_CONSENT;
  // The request to start at once, as on the order card: payment waits for it.
  public startConsent = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: RenderUnlockDialogData,
    private readonly dialogRef: MatDialogRef<RenderUnlockDialogComponent, 'pay' | undefined>,
  ) {}

  public onBack(): void {
    this.dialogRef.close();
  }

  public onPay(): void {
    if (!this.startConsent) {
      return;
    }
    this.dialogRef.close('pay');
  }
}
